import SocialMediaIcons from "./socialmediacomponent";
import { useHistory } from "react-router-dom";
import Fondo from "../assets/images/fondo.jpg";
import Logo from "../assets/images/logo1.png";
import { useTranslation } from "react-i18next";

const Portada = () => {
  const history = useHistory();
  const { t } = useTranslation();

  return (
    <section id="portada" className="bg-cover bg-center relative flex flex-col items-center h-screen lg:h-screen">
      <img
        alt="No encontrado"
        className="absolute top-0 right-0 bottom-0 object-cover w-full h-full"
        src={Fondo}
      />

      <div className="flex flex-col items-center justify-center inset-0 z-0 p-2 bg-bgPrimary opacity-[0.85] w-[90%] lg:w-[60%] xl:w-[60%] 2xl:w-[45%] h-auto max-h-[550px] m-auto rounded-xl">
        <img
          alt="no encontrado"
          className="object-cover w-[80%] sm:w-[50%] md:w-[38%] mt-0 lg:mt-4"
          src={Logo}
        />

        <div className="relative z-10 flex flex-col justify-center items-center text-white text-center">
          <h1 className="text-[32px] sm:text-[40px] md:text-[48px] lg:text-[54px] font-bold mb-2">
            {t("portada.LIVE")} <span className="text-textSecundary font-bold"> {t("portada.CLEAN")} </span> -  {t("portada.WORK")}  <span className="text-textSecundary font-bold"> {t("portada.CLEAN")} </span>
          </h1>
          <p className="w-full mb-6 text-[12px] sm:text-[12px] md:text-[16px] text-white px-4">
          {t("portada.description")}
          </p>
          <button onClick={()=>history.push("/quote")} className="bg-bgSecundary hover:bg-blue-600 text-white px-6 py-3 rounded-lg font-semibold text-[12px] sm:text-[12px] transition duration-300 ease-in-out mb-2">
          {t("portada.button")}
          </button>
        </div>
      </div>

      <div className="absolute bottom-8 right-4">
        <SocialMediaIcons />
      </div>
    </section>
  );
};


export default Portada;
